module.exports = __webpack_public_path__ + "static/media/pharmacies.d373cc3e.jpg";